import React  from 'react';  

export const practitionerviewConfig = [
 
  {
    auth: ['user'],
    routes: [
      {
        exact:false,
        path: '/statements/pract-view',
        component: React.lazy(() => import('./ViewPract')),
      },
    ],
  },
 
];